
const needList ={
      path: '/DetailList/needList',
      component: resolve => require(['@/views/DetailList/needList'], resolve),
      name: 'needList',
      meta: {
        title: '需求列表',
        keepActive:true
      }
    };
const needTotal ={
    path: '/DetailList/needTotal',
    component: resolve => require(['@/views/DetailList/needTotal'], resolve),
    name: 'needTotal',
    meta: {
      title: '需求统计',
      keepActive:true
    }
  };
const commentCount = {
  path: '/DetailList/commentCount',
    component: resolve => require(['@/views/DetailList/commentCount'], resolve),
    name: 'commentCount',
    meta: {
      title: '评价统计',
      keepActive:true
    }
}
const needsComment =  {
  path: '/DetailList/needsComment',
  component: resolve => require(['@/views/DetailList/needsComment'], resolve),
  name: 'needsComment',
  meta: {
    title: '需求评价',
    keepActive:true
  }
};
const needsPledge =  {
  path: '/DetailList/needsPledge',
  component: resolve => require(['@/views/DetailList/needsPledge'], resolve),
  name: 'needsPledge',
  meta: {
    title: '保证金工单',
    keepActive:true
  }
};
const needsStarTag =  {
  path: '/DetailList/needsStarTag',
  component: resolve => require(['@/views/DetailList/needsStarTag'], resolve),
  name: 'needsStarTag',
  meta: {
    title: '需求评价标签',
  }
};
const needsComplaint =  {
  path: '/DetailList/needsComplaint',
  component: resolve => require(['@/views/DetailList/needsComplaint'], resolve),
  name: 'needsComplaint',
  meta: {
    title: '需求投诉',
    keepActive:true
  }
};
const ComplaintOption =  {
  path: '/DetailList/ComplaintOption',
  component: resolve => require(['@/views/DetailList/ComplaintOption'], resolve),
  name: 'ComplaintOption',
  meta: {
    title: '需求投诉选项'
  }
};
const truckDetail =  {
  path: '/DetailList/truckDetail',
  component: resolve => require(['@/views/DetailList/truckDetail'], resolve),
  name: 'truckDetail',
  meta: {
    title: '货运信息'
  }
};
const needsAccountLog = {
    path: '/DetailList/needsAccountLog',
    component: resolve => require(['@/views/DetailList/needsAccountLog'], resolve),
    name: 'needsAccountLog',
    meta: {title: '需求积分日志'}
};

const needsFilter = {
    path: '/DetailList/needsFilter',
    component: resolve => require(['@/views/DetailList/needsFilter'], resolve),
    name: 'needsFilter',
    meta: {title: '需求单筛选'}
};

export default [needList,needTotal,commentCount,needsComment,needsComplaint,ComplaintOption,needsStarTag,truckDetail,needsPledge,needsAccountLog,needsFilter]



// WEBPACK FOOTER //
// ./src/router/modules/DetailList.js